// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\routes\\\\login.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\routes\\login.tsx");
  import.meta.hot.lastModified = "1759761980446.823";
}
// REMIX HMR END

import { SignIn } from "~/components/auth";
import { PublicRoute } from "~/components/RouteProtection";
export const meta = () => {
  return [{
    title: "Login | Nomadics"
  }, {
    name: "description",
    content: "Sign in to your account"
  }];
};
export default function Login() {
  return <PublicRoute>
      <SignIn />
    </PublicRoute>;
}
_c = Login;
var _c;
$RefreshReg$(_c, "Login");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;